module.exports = __webpack_public_path__ + "img/R01_02.bc5677c6.jpg";